var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center pa-2 pt-8 pb-6"},[_c('v-img',{staticClass:"mb-5",attrs:{"height":"200px","contain":"","src":"/images/chat.svg"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }